import { generateClient } from "seenspire-api-client";

import { api, openApi } from "./api";

const loadClient = () => {
  return generateClient({
    basePath: process.env.REACT_APP_API,
    // Statistics/airtime Cloud Functions; empty where a stage has none.
    extendedBasePath: process.env.REACT_APP_FUNCTIONS || "",
    api,
    openApi,
  });
};

export default { loadClient };
